import { createSlice } from '@reduxjs/toolkit'
import { IAppliance } from '../../types'
import {
  fetchAppliancesAsync,
  fetchAppliancesDetailsAsyncBuilder,
} from './asyncRequest'

export interface AppliancesState {
  waterFiltrationOptions: {label: string, value: string}[],
  brands: {label: string, value: string}[],
  data: IAppliance[] ,
  loading: boolean,
  error: string | null,
}

const initialState: AppliancesState = {
  waterFiltrationOptions: [
    {label: 'Water pitcher', value:'water_pitcher'},
    {label: 'Refrigerator filter', value:'refrigerator_filter'},
    {label: 'Under sink system', value:'under_sink_system'},
    {label: 'Counter top filter', value:'counter_top_filter'},
    {label: 'Whole home system', value:'whole_home_system'},
    // SIPP-828: copy tuned to match the Recommendations tab equipment picker
    // and give unfiltered users an honest way to answer the question.
    {label: "None / I don't use a filter", value:'none'}
  ],
  brands: [
    {label:'Samsung', value:'samsung'},
    {label:'LG', value:'lg'},
    {label:'Whirlpool', value:'whirlpool'},
    {label:'GE', value:'ge'},
    {label:'Amana', value:'amana'},
    {label:'Maytag', value:'maytag'},
    {label:'Sears-Kenmore', value:'sears-kenmore'},
    {label:'Frigidaire', value:'frigidaire'},
    {label:'Other', value:'other'}

  ],
  data: [],
  loading: false,
  error: null
}

const AppliancesSlice = createSlice({
  name: 'appliancesSlice',
  initialState,
  reducers: {
    resetForm: () => initialState,
  },
  extraReducers:(builder) => {
    fetchAppliancesDetailsAsyncBuilder(builder);
  }
} )

export const AppliancesActions = {
  ...AppliancesSlice.actions,
  fetchAppliancesAsync
}

export const AppliancesReducer = AppliancesSlice.reducer